module.exports = __webpack_public_path__ + "img/e2.97af9ea6.jpeg";